import clsx from "clsx";
import Link from "next/link";
import { FlexBox } from "src/lib/components/salify-next-layout/default/components/flex-box";
import MobileHeader from "./mobile-header";
import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";
import { Box, Button } from "@mui/material";
import Typography from "@mui/material/Typography";
import Image from "next/image";
import { CartButtonWithSwipeableDrawer } from "src/lib/components/header/default";
import { HeaderWrapper, HotlineText, StyledHeaderContainer } from "./styles";
import SearchInput from "./search-input";
import { toAssetImages } from "src/lib/utils";
// ==============================================================
const Header = ({ isFixed, ...props }) => {
  const CONTENT_FOR_LARGE_DEVICE = (
    <>
      <FlexBox mr={2} minWidth="70px" alignItems="center">
        <Link href="/" style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {props.logoUrl && (
            <Image
              src={toAssetImages(props.logoUrl)}
              alt=""
              width={props.logoWidth ?? 50}
              height={props.logoHeight ?? 50}
            />
          )}
          <Typography variant="h4" component="h1" fontWeight="700">
            {props.name}
          </Typography>
        </Link>
      </FlexBox>

      <FlexBox justifyContent="start" flex="1 1 0">
        <SearchInput />
      </FlexBox>

      <FlexBox gap={1.5} alignItems="center">
        {props.hotline && (
          <Button
            component={Link}
            href={`tel:${props.hotline}`}
            variant="outlined"
            sx={{
              borderColor: "#E4E4EB",
              color: "#555770",
              fontWeight: "normal",
              borderRadius: 2,
            }}
          >
            <HeadsetMicIcon color="#555770" fontSize="18px" />
            &nbsp; Hotline: &nbsp;
            <HotlineText>{props.hotline}</HotlineText>
          </Button>
        )}
        <Button
          href={`/collection`}
          variant="outlined"
          sx={{
            borderColor: "#E5F3DB",
            background: "#E5F3DB",
            fontWeight: "normal",
            borderRadius: 2,
            padding: 1,
          }}
        >
          <Image src={"/assets/icons/gift.svg"} alt={"gift-button"} width="18" height="18" />
        </Button>
        <CartButtonWithSwipeableDrawer
          cartUrl={props.cartUrl}
          checkoutUrl={props.checkoutUrl}
          productUrlPrefix={props.productUrlPrefix}
        />
      </FlexBox>
    </>
  );
  return (
    <HeaderWrapper className={clsx(props.className)}>
      <StyledHeaderContainer>
        <Box width="100%" display={{ xs: "none", sm: "flex" }} gap={1.5}>
          {CONTENT_FOR_LARGE_DEVICE}
        </Box>
        <Box width="100%" display={{ xs: "block", sm: "none" }}>
          <MobileHeader {...props} />
        </Box>
      </StyledHeaderContainer>
    </HeaderWrapper>
  );
};

export default Header;
